import './style.css';

const API_URL = '/a/pbc-shopthelook/look-settings/';

window.pbcShopTheLookWidget = {
  getShopthelookConfig: () => {
    if (lookProductPage) {
        if (lookDataJson) {
          if (lookDataJson.enabled){
            window.pbcShopTheLookWidget.appendStyleVariables(lookDataJson)
            return window.pbcShopTheLookWidget.renderWidget(lookDataJson)
          } else {
            document.querySelector('.pbc-stl').remove()
          }
        }
    }
  },
  shopTheLookProcess: () => {
    function openPopUp() {
      if (window.innerWidth <= 768) {
        const popUp = this.parentNode.querySelector('.pbc-stl__product-popup');

        const newPopUp = document.createElement('div')
        newPopUp.classList.add('pbc-stl__product-popup-backdrop')
        newPopUp.innerHTML = popUp.innerHTML

        const backdrop = document.querySelector('.pbc-stl__backdrop')

        backdrop.appendChild(newPopUp)

        document.querySelector('.pbc-stl__product-popup-backdrop').classList.toggle('active');
        backdrop.classList.toggle('active')

        const closePopUpBtns = document.querySelector('.pbc-stl__product-popup-backdrop').querySelectorAll('.pbc-stl__product-popup-close ')
        closePopUpBtns.forEach(el => {
          el.addEventListener('click', closePopUp)
        })
      } else {
        const popUp = this.parentNode.querySelector('.pbc-stl__product-popup');

        popUp.classList.toggle('active')

        const popUpRect = popUp.getBoundingClientRect()
        const viewportWidth = window.innerWidth;
        const viewportHeight = window.innerHeight;

        if (popUpRect.right > viewportWidth) {
          const newPopUpLeftPosition = popUpRect.right - viewportWidth + 95
          popUp.style.left = `-${newPopUpLeftPosition}px`
        }
        if (popUpRect.bottom > viewportHeight) {
          const newPopUpTopPosition = popUpRect.bottom - viewportHeight + 20
          popUp.style.top = `-${newPopUpTopPosition}px`
        }
      }
    }

    function closePopUp() {
      if (window.innerWidth <= 768) {
        const popUp = document.querySelector('.pbc-stl__product-popup-backdrop.active');
        const backdrop = document.querySelector('.pbc-stl__backdrop.active')

        backdrop.innerHTML = ''
        popUp.classList.toggle('active')
        backdrop.classList.toggle('active')
      } else {
        const popUp = this.parentNode;
        popUp.classList.toggle('active')
      }
    }

    function shopTheLookListeners() {
      const openPopUpBtns = document.querySelectorAll('.pbc-stl__product-item-btn')
      openPopUpBtns.forEach(el => {
        el.addEventListener('click', openPopUp)
      })
      const closePopUpBtns = document.querySelectorAll('.pbc-stl__product-popup-close ')
      closePopUpBtns.forEach(el => {
        el.addEventListener('click', closePopUp)
      })
    }

    shopTheLookListeners()
  },
  renderHalfImageSection: (look, contentBlock, sectionImage) => {
    let storePath = window.location.origin;
    let halfContentBox = document.createElement('div')
    halfContentBox.classList.add('pbc-stl__content-half')

    let imageBox = document.createElement('div')
    imageBox.classList.add('pbc-stl__image-half-box')

    let productList = document.createElement('ul')
    productList.classList.add('pbc-stl__product-list-half')

    sectionImage.src = look.sectionImage.url
    sectionImage.alt = 'Look image'
    sectionImage.classList.add('pbc-stl__image-half')
    imageBox.appendChild(sectionImage)

    look.productIds.forEach(product => {

      let productLabel = `
        <button 
          class="pbc-stl__product-item-btn-half" 
          type="button" 
          style="top: ${product.coordinates.top}; 
                 left: ${product.coordinates.left}; 
                 transform: translate(-${product.coordinates.top}, -${product.coordinates.left});"
        ></button>`
      let productListItem = `
        <li class="pbc-stl__product-item-half">
          ${look.productModalShowImage && product.image ? `<img class="pbc-stl__product-image-half"  src="${product.image}" alt="${product.title}" width="100">` : ''}
          <div class="pbc-stl__product-info">
            <h3 class="pbc-stl__product-title-half">${product.title}</h3>
            ${look.productModalShowDescription !== '' ? `<p class="pbc-stl__product-variant-title-half">${product.variantTitle}</p>` : ''}
            <form method="post" action="/cart/add" accept-charset="UTF-8" class="form pbc-stl__product-form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form" data-editor-form-attribute="">
              <input type="hidden" name="id" value="${product.variantId}">
              <input type="hidden" name="quantity" min="1" value="1">
              <button class="pbc-stl__product-btn-half pbc-stl__product-btn--add-half">
                Add to cart
              </button>
              <a href="${storePath}/products/${product.handle}?variant=${product.variantId}" class="pbc-stl__product-btn-half pbc-stl__product-btn--link-half">
                View product
              </a>
            </form>
          </div>
        </li>
        `
      imageBox.insertAdjacentHTML("beforeend", productLabel)
      productList.insertAdjacentHTML("beforeend", productListItem)
    })

    halfContentBox.appendChild(imageBox)
    halfContentBox.appendChild(productList)
    contentBlock.appendChild(halfContentBox)
  },
  renderFullImageSection: (look, contentBlock, sectionImage) => {
    document.body.insertAdjacentHTML('beforeend', '<div class="pbc-stl__backdrop"></div>')
    let storePath = window.location.origin;
    let productList = document.createElement('ul')
    productList.classList.add('pbc-stl__product-list')

    sectionImage.src = look.sectionImage.url
    sectionImage.alt = 'Look image'
    sectionImage.classList.add('pbc-stl__image')

    look.productIds.forEach(product => {

      let productListItem = `
        <li class="pbc-stl__product-item" style="top: ${product.coordinates.top}; left: ${product.coordinates.left}; transform: translate(-${product.coordinates.top}, -${product.coordinates.left});">
          <button class="pbc-stl__product-item-btn" style="border-color: ${look.productLabelBorderColor};background-color: ${look.productLabelColor}" type="button"></button>
          <div class="pbc-stl__product-popup">
            <button class="pbc-stl__product-popup-close">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" width="50px" height="50px">
                <path d="M 9.15625 6.3125 L 6.3125 9.15625 L 22.15625 25 L 6.21875 40.96875 L 9.03125 43.78125
                        L 25 27.84375 L 40.9375 43.78125 L 43.78125 40.9375 L 27.84375 25 L 43.6875 9.15625 L 40.84375
                        6.3125 L 25 22.15625 Z"
                />
              </svg>
            </button>
            ${look.productModalShowImage && product.image ? `<img class="pbc-stl__product-image"  src="${product.image}" alt="${product.title}" width="150">` : ''}
            <h3 class="pbc-stl__product-title">${product.title}</h3>
            ${look.productModalShowDescription !== '' ? `<p class="pbc-stl__product-variant-title">${product.variantTitle}</p>` : ''}
            <form method="post" action="/cart/add" accept-charset="UTF-8" class="form pbc-stl__product-form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form" data-editor-form-attribute="">
              <input type="hidden" name="id" value="${product.variantId}">
              <input type="hidden" name="quantity" min="1" value="1">
              ${look.productModalShowAddToCartBtn ? `<button class="pbc-stl__product-btn pbc-stl__product-btn--add">${look.addToCartBtnText}</button>` : ''}
              ${look.productModalShowViewProductButton ? `<a href="${storePath}/products/${product.handle}?variant=${product.variantId}" class="pbc-stl__product-btn pbc-stl__product-btn--link">View product</a>` : ''}
            </form>
          </div>
        </li>
        `
      productList.insertAdjacentHTML("beforeend", productListItem)
    })

    contentBlock.appendChild(sectionImage)
    contentBlock.appendChild(productList)
    window.pbcShopTheLookWidget.shopTheLookProcess()
  },
  renderWidget: (look) => {
    let shopTheLookWidget = document.querySelector('.pbc-stl');
    let contentBlock = shopTheLookWidget.querySelector('.pbc-stl__content')
    let sectionImage = document.createElement('img')

    const parentSection = shopTheLookWidget?.parentElement?.parentElement;
    if (parentSection) {
      parentSection.style.position = 'relative';
      parentSection.style.zIndex = '1';
    }

    if (look.sectionType.value === 'halfImage') {
      window.pbcShopTheLookWidget.renderHalfImageSection(look, contentBlock, sectionImage)
    } else {
      window.pbcShopTheLookWidget.renderFullImageSection(look, contentBlock, sectionImage)
    }
  },
  appendStyleVariables: (look) => {
    let rootStyles = '';

    rootStyles += ':root{\n';

    rootStyles += '--stl-addToCartBtnTextColor: ' + look.addToCartBtnTextColor + ';\n';
    rootStyles += '--stl-addToCartBtnBackgroundColor: ' + look.addToCartBtnBackgroundColor + ';\n';
    rootStyles += '--stl-addToCartBtnBorderColor: ' + look.addToCartBtnBorderColor + ';\n';
    rootStyles += '--stl-addToCartBtnFontWeight: ' + look.addToCartBtnFontWeight.value + ';\n';
    rootStyles += '--stl-addToCartBtnFontSize: ' + look.addToCartBtnFontSize + 'px;\n';
    rootStyles += '--stl-addToCartBtnBorderRadius: ' + look.addToCartBtnBorderRadius + 'px;\n';
    rootStyles += '--stl-addToCartBtnBackgroundHoverColor: ' + look.addToCartBtnBackgroundHoverColor + ';\n';
    rootStyles += '--stl-addToCartBtnBorderHoverColor: ' + look.addToCartBtnBorderHoverColor + ';\n';

    rootStyles += '--stl-viewProductBtnTextColor: ' + look.viewProductBtnTextColor + ';\n';
    rootStyles += '--stl-viewProductBtnBackgroundColor: ' + look.viewProductBtnBackgroundColor + ';\n';
    rootStyles += '--stl-viewProductBtnBorderColor: ' + look.viewProductBtnBorderColor + ';\n';
    rootStyles += '--stl-viewProductBtnFontWeight: ' + look.viewProductBtnFontWeight.value + ';\n';
    rootStyles += '--stl-viewProductBtnFontSize: ' + look.viewProductBtnFontSize + 'px;\n';
    rootStyles += '--stl-viewProductBtnBorderRadius: ' + look.viewProductBtnBorderRadius + 'px;\n';
    rootStyles += '--stl-viewProductBtnBackgroundHoverColor: ' + look.viewProductBtnBackgroundHoverColor + ';\n';
    rootStyles += '--stl-viewProductBtnBorderHoverColor: ' + look.viewProductBtnBorderHoverColor + ';\n';

    rootStyles += '--stl-productLabelBorderColor: ' + look.productLabelBorderColor + ';\n';
    rootStyles += '--stl-productLabelColor: ' + look.productLabelColor + ';\n';

    rootStyles += '}'

    let styleVariables = document.createElement('style');
    styleVariables.id = 'pbcCssVariables';
    styleVariables.textContent = rootStyles;

    let globalStyles = document.createElement('link');
    globalStyles.rel = 'stylesheet';
    globalStyles.href = 'https://shopthelook.polarbearapps.com/frontend/style.css';

    if (process.env.ENVIRONMENT === 'dev') {
      globalStyles.href = 'https://shopthelook/frontend/style.css';
    } else if (process.env.ENVIRONMENT === 'stage') {
      globalStyles.href = 'https://shopthelook-staging.polarbearapps.com/frontend/style.css';
    }


    document.getElementsByTagName('head')[0].appendChild(styleVariables);
    document.getElementById('pbcCssVariables').after(globalStyles);
  },
  init: () => {
    window.pbcShopTheLookWidget.getShopthelookConfig()
  }
}

let shopTheLookWidgets = document.querySelectorAll('.pbc-stl');

if (shopTheLookWidgets.length > 0) {
  window.pbcShopTheLookWidget.init();
}
